export default function FuelChart({ history, events }) {
  const raw = (history.fuel_level_liters || [])
    .map(p => ({ ts: Number(p.ts), val: parseFloat(p.value) }))
    .filter(p => !isNaN(p.val))
    .sort((a, b) => a.ts - b.ts);

  if (raw.length < 2) return (
    <div style={{ height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--tg-text-muted)', fontSize: 12 }}>
      Not enough data yet
    </div>
  );

  if (raw.every(p => p.val === 0)) return (
    <div style={{ height: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--tg-text-muted)', fontSize: 12 }}>
      No fuel data
    </div>
  );

  const W = 560, H = 110;
  const PAD = { top: 8, right: 8, bottom: 20, left: 32 };
  const iW = W - PAD.left - PAD.right;
  const iH = H - PAD.top - PAD.bottom;

  const minT = raw[0].ts, maxT = raw[raw.length-1].ts;
  // Floor the top of the y-axis at 10 L so a near-empty tank still has visual
  // room above the line; pad the bottom by 10% of the range to avoid the line
  // hugging the x-axis when the values barely move.
  const vals = raw.map(p => p.val);
  const maxRaw = Math.max(...vals, 10);
  const maxV = maxRaw * 1.15;
  const minV = Math.max(0, Math.min(...vals) - maxRaw * 0.1);
  const range = maxV - minV || 1;

  const xS = t => ((t - minT) / (maxT - minT || 1)) * iW;
  const yS = v => iH - ((v - minV) / range) * iH;

  const linePath = raw.map((p, i) => (i === 0 ? 'M' : 'L') + ' ' + xS(p.ts).toFixed(1) + ' ' + yS(p.val).toFixed(1)).join(' ');
  const areaPath = linePath + ' L ' + xS(maxT).toFixed(1) + ' ' + iH + ' L 0 ' + iH + ' Z';

  const hours = [];
  const step = Math.ceil((maxT - minT) / (3600000 * 4)) * 3600000;
  for (let t = Math.ceil(minT / step) * step; t <= maxT; t += step) {
    hours.push({ ts: t, label: new Date(t).getHours() + ':00' });
  }

  return (
    <svg viewBox={'0 0 ' + W + ' ' + H} style={{ width: '100%', display: 'block' }}>
      {[0.33, 0.66, 1].map((p, i) => (
        <g key={i}>
          <line x1={PAD.left} y1={PAD.top + iH * (1-p)} x2={PAD.left + iW} y2={PAD.top + iH * (1-p)} stroke="var(--tg-border-default)" strokeWidth="0.5" />
          <text x={PAD.left - 4} y={PAD.top + iH * (1-p) + 3} textAnchor="end" fontSize="8" fill="var(--tg-text-muted)">{Math.round(minV + range * p)}</text>
        </g>
      ))}
      <g transform={'translate(' + PAD.left + ',' + PAD.top + ')'}>
        <path d={areaPath} fill="var(--tg-teal-500)" opacity="0.06" />
        <path d={linePath} fill="none" stroke="var(--tg-teal-500)" strokeWidth="1.5" />
        {events && events.map((ev, i) => {
          const closest = raw.reduce((best, p) => Math.abs(p.ts - ev.ts) < Math.abs(best.ts - ev.ts) ? p : best, raw[0]);
          return (
            <circle key={i} cx={xS(ev.ts)} cy={yS(closest.val)} r="4"
              fill={ev.type === 'theft' ? 'var(--tg-danger-500)' : 'var(--tg-teal-500)'}
              stroke="var(--tg-bg-surface)" strokeWidth="1.5" />
          );
        })}
      </g>
      {hours.map((h, i) => (
        <text key={i} x={PAD.left + xS(h.ts)} y={H - 4} textAnchor="middle" fontSize="8" fill="var(--tg-text-muted)">{h.label}</text>
      ))}
    </svg>
  );
}
